import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { cn } from '@/utils/cn';

const LINKS = [
  { to: '/assets', end: true, labelKey: 'nav.assets' as const },
  { to: '/assets/rentals', end: false, labelKey: 'nav.rentals' as const },
];

export const AssetsSubnav = () => {
  const { t } = useTranslation('assets');

  return (
    <nav className="mb-4 flex flex-wrap gap-2" aria-label={t('title')}>
      {LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.end}
          className={({ isActive }) =>
            cn(
              'rounded-md px-3 py-1.5 text-body-sm',
              isActive
                ? 'bg-brand/10 font-medium text-brand'
                : 'text-fg-secondary hover:bg-surface-muted hover:text-fg',
            )
          }
        >
          {t(link.labelKey)}
        </NavLink>
      ))}
    </nav>
  );
};
